import { render, staticRenderFns } from "./DashboardHeading.vue?vue&type=template&id=9a2a99d0&scoped=true&"
import script from "./DashboardHeading.vue?vue&type=script&lang=js&"
export * from "./DashboardHeading.vue?vue&type=script&lang=js&"
import style0 from "./DashboardHeading.vue?vue&type=style&index=0&id=9a2a99d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a2a99d0",
  null
  
)

export default component.exports